import { useState } from "react";
import { faqs } from "../../../mocks/faqs";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section className="mx-auto max-w-4xl px-4 md:px-6 py-16 md:py-20">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="text-center">
        <p className="text-sm text-primary-600 font-medium">常见问题</p>
        <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">
          你可能想知道的
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-foreground-700">
          关于集数、观看顺序、世界观与结局的常见疑问，这里一次说清楚。
        </p>
      </div>

      <div className="mt-10 space-y-3">
        {faqs.map((f, i) => {
          const open = openIndex === i;
          return (
            <div
              key={f.q}
              className={`overflow-hidden rounded-2xl border transition-colors ${
                open ? "border-primary-200 bg-primary-50/40" : "border-background-200/70 bg-background-50"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenIndex(open ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                aria-expanded={open}
              >
                <span className="font-medium text-foreground-950">{f.q}</span>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-transform ${
                    open ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700"
                  }`}
                >
                  <i className="ri-add-line" />
                </span>
              </button>
              {open && (
                <p className="px-5 pb-5 text-sm leading-7 text-foreground-700">{f.a}</p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}